const columns = {
  	"date_in_service":{
        "label": "Date In Service",
        "field": "date_in_service",
        "filterable": true,
        "fpFieldType":"custom_date",
        "hidden":false,
        "filterOptions": {
            "enabled": false,
            "placeholder": "MM/DD/YYYY",
            "filterValue": "",
            "trigger": "enter"
        }
	},
	"item_serial_number":{
		"label": "Item Serial Number",
		"field": "vin",
		"fpFieldType":"text",
		"filterable": true,
		"hidden":false,
		"filterOptions": {
			"enabled": false,
			"placeholder": "VIN",
			"filterValue": "",
			"trigger": "enter"
		}
	},
	"equipment_group": {
		"label": "Equipment Group",
		"field": "asset_group",
		"fpFieldType":"text",
		"filterable": true,
		"hidden":false,
		"filterOptions": {
			"enabled": false,
			"placeholder": "Group",
			"filterValue": "",
			"trigger": "enter"
		}
	},
	"equipment_group_name":{
		"label": "Equipment Group Name",
		"field": "asset_group_name",
		"fpFieldType":"text",
		"filterable": true,
		"hidden":false,
		"filterOptions": {
			"enabled": false,
			"placeholder": "Group Name",
			"filterValue": "",
			"trigger": "enter"
		}
	},
	"equipment_manufacturer":{
		"label": "Equipment Manufacturer",
		"field": "vehicle_manufacturer",
		"fpFieldType":"text",
		"filterable": true,
		"hidden":false,
		"filterOptions": {
			"enabled": false,
			"placeholder": "Equipment Manufacturer",
			"filterValue": "",
			"trigger": "enter"
		}
	},
	"manufacturer_name":{
		"label": "Manufacturer Name",
		"field": "vehicle_manufacturer_desc",
		"fpFieldType":"text",
		"filterable": true,
		"hidden":false,
		"filterOptions": {
			"enabled": false,
			"placeholder": "Equipment Manufacturer",
			"filterValue": "",
			"trigger": "enter"
		}
	},
	"equipment_model":{
		"label": "Equipment Model",
		"field": "vehicle_model",
		"fpFieldType":"text",
		"filterable": true,
		"hidden":false,
		"filterOptions": {
			"enabled": false,
			"placeholder": "Equipment Model",
			"filterValue": "",
			"trigger": "enter"
		}
	},
	"model_description":{
		"label": "Model Description",
		"field": "vehicle_model_desc",
		"fpFieldType":"text",
		"filterable": true,
		"hidden":false,
		"filterOptions": {
			"enabled": false,
			"placeholder": "Equipment Model",
			"filterValue": "",
			"trigger": "enter"
		}
	},
	"equipment_type":{
		"label": "Equipment Type",
		"field": "asset_type",
		"fpFieldType":"option",
		"filterable": true,
		"hidden":false,
		"filterOptions": {
			"enabled": false,
			"placeholder": "Asset Type",
			"filterValue": "",
			"trigger": "enter"
		}
	},
	"equipment_type_description":{
		"label": "Equipment Type Description",
		"field": "asset_type_desc",
		"fpFieldType":"text",
		"filterable": true,
		"hidden":false,
		"filterOptions": {
			"enabled": false,
			"placeholder": "Asset Type",
			"filterValue": "",
			"trigger": "enter"
		}
	},
	"feature_code":{
		"label": "Feature Code",
		"field": "feature_code",
		"fpFieldType":"text",
		"filterable": true,
		"hidden":false,
		"filterOptions": {
			"enabled": false,
			"placeholder": "Feature Code",
			"filterValue": "",
			"trigger": "enter"
		}
	},
	"feature_description":{
		"label": "Feature Description",
		"field": "feature_name",
		"fpFieldType":"text",
		"filterable": true,
		"hidden":false,
		"filterOptions": {
			"enabled": false,
			"placeholder": "Feature Name",
			"filterValue": "",
			"trigger": "enter"
		}
	},
	"feature_value":{
		"label": "Feature Value",
		"field": "feature_value",
		"filterable": true,
		"fpFieldType":"text",
		"hidden":false,
		"filterOptions": {
			"enabled": false,
			"placeholder": "Feature Value",
			"filterValue": "",
			"trigger": "enter"
		},
	}
}


export default columns;



// WEBPACK FOOTER //
// ./src/constants/common-columns.js